<template>
  <div class="content">
    <!--列表-->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>团购管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row type="flex" :gutter="20">
        <el-col
          :span="1"
          v-if="$utils.checkPer('car-group.store')"
          style="margin-right: 10px">
          <el-button type="primary" size="mini" @click="addData">新增</el-button>
        </el-col>

        <el-col :span="3">
          <el-input
            v-model="where.group_name"
            style="width: 200px"
            placeholder="团购名称"
            clearable
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="index(where)" size="mini">查询</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-table v-loading="loading" border :data="tableData" height="650" style="margin-bottom:5px">
          <el-table-column
            type="index"
            width="50"
            fixed
            label="序号"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="group_name" label="团购名称" align="center">
          </el-table-column>
          <el-table-column
            prop="get_brand.brand_name"
            label="所属品牌"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="group_logo"
            align="center"
            label="活动主画面"
            width="150"
          >
            <template slot-scope="scope">
              <el-image
                :src="scope.row.group_logo | getImg"
                :preview-src-list="scope.row.group_logo | getImgArr"
              ></el-image>
            </template>
          </el-table-column> -->
          <el-table-column prop="group_addr" label="团购地址" align="center">
          </el-table-column>
          <el-table-column prop="group_price" label="团购价格" align="center">
          </el-table-column>
          <el-table-column
            prop="group_start_time"
            label="开始时间"
            align="center"
          >
            <template slot-scope="scope">
              {{ $utils.isDate(scope.row.group_start_time) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="group_end_time"
            label="结束时间"
            align="center"
          >
            <template slot-scope="scope">
              {{ $utils.isDate(scope.row.group_end_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="group_hot" align="center" label="热门团购">
            <template slot-scope="scope">
              <span>{{ scope.row.group_hot | getHot }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            align="center"
            label="操作"
            width="250"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                v-if="$utils.checkPer('car-group.store')"
                @click="editMessage(scope.row)"
                type="primary" 
                plain
                >修改</el-button
              >
              <el-button
                size="small"
                v-if="$utils.checkPer('car-group.store')"
                @click="delMessage(scope.row)"
                type="danger"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="index(where)"
          background
          :current-page.sync="where.page"
          :page-size="where.pagesize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </div>
    <!-- 弹出层 -->
    <el-dialog
      title="团购管理"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
      <myForm @emitcargroup="onemitcargroup" :edit="isupdata" :row="updataList"></myForm>
    </el-dialog>
  </div>
</template>

<script>
import myForm from "./form";
import { car_group,addcar_group,modifycar_group,delcar_group } from "../../api/api";
export default {
  name: "car-group",
  data() {
    return {
      tableData: [],
      keyword: [],
      loading: false,
      where: {
        group_name: "",
        page: 1,
        pagesize: 10,
      },
      total: 0,
      dialogVisible: false,
      updataList:"",
      isupdata:false,
      isupdataid:0,

    };
  },
  components: {
    myForm,
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      car_group(this.where).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.total = data.total;
        this.tableData = data.data;
        this.loading = false;
      });
    },
    addData() {
      this.dialogVisible = true;
    },
    onemitcargroup(obj){
      if(obj.form){
        if(this.isupdata == false){
          addcar_group(obj.form).then(msg=>{
            let {data} = msg;
            data = JSON.parse(data);
            console.log(data)
            if(data.code == 200){
              this.$message.success(data.msg)
              this.getList();
            }else{
              this.$message.error(data.msg)
            }
          })
        }
        if(this.isupdata == true){
          modifycar_group(this.isupdataid,obj.form).then(msg=>{
            let {data} = msg;
            data = JSON.parse(data);
            if(data.code == 200){
              this.$message.success(data.msg);
              this.getList();
            }else{
              this.$message.error(data.msg);
            }
          })
        }
      }
      this.dialogVisible = false;
      this.isupdataid = 0;
      this.isupdata = false;
      this.updataList = "";
    },
    editMessage(scope) {
      this.dialogVisible = true;
      this.isupdataid = scope.id;
      this.isupdata = true;
      this.updataList = scope;
    },
    delMessage(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delcar_group(row.id).then(msg=>{
            let {data} = msg;
            data = JSON.parse(data);
            if(data.code == 200){
              this.$message.success(data.msg);
              this.getList();
            }else{
              this.$message.error(data.msg);
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.where.pagesize = val;
      this.getList();
    },
    index(e) {
      this.where = e;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    close() {
      this.dialogVisible = false;
    },
  },
  filters: {
    getImg: function (value) {
      if (value == "[]" || value == null || value == "") return "";
      let res = JSON.parse(value);
      if (typeof res[0].response == "undefined") return "";
      let url = window.location.origin + "/" + res[0].response.path;
      return url;
    },
    getImgArr: function (value) {
      if (value == "[]" || value == null || value == "") return [];
      let res = JSON.parse(value);
      if (typeof res[0].response == "undefined") return [];
      let url = [];
      url.push(window.location.origin + "/" + res[0].response.path);
      return url;
    },
    getText: function (value) {
      if (!value || value == "") return "";
      let res_json = JSON.parse(value);
      let res = "";
      for (var i = 0; i < res_json.length; i++) {
        res += res_json[i] + "\n";
      }
      console.log(res);
      return res;
    },
    getHot: function (value) {
      //if (!value || value == '') return '';
      if (value) {
        return "是";
      } else {
        return "否";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.el-col-3 {
  width: 210px;
}
.el-col-1 {
  width: 68px;
}
.el-breadcrumb {
  margin-bottom: 15px;
}
</style>
